import { useMemo } from 'react';
import {
  EvidenceViewer,
  GhOAuthReturn,
  ghOAuthParamsFromSearch,
  packUrlFromSearch
} from '@lt-web-platform/evidence-viewer';

/**
 * Public standalone shell. The embed contract (cerebro/evidence/evidence.md):
 * a single ?pack=<URL-encoded url> query param, read ONCE at mount — hosts
 * refresh the iframe src to swap packs. Without the param, the shared
 * component's landing screen owns the UX (drop zone, picker, URL form).
 *
 * GitHub OAuth return (?code&state from the Connect GitHub flow) is handled
 * HERE, before the viewer mounts — the kaneai host mount never sees it.
 */
export default function App() {
  const oauth = useMemo(
    () => ghOAuthParamsFromSearch(window.location.search),
    []
  );
  const initialPack = useMemo(
    () => packUrlFromSearch(window.location.search),
    []
  );
  if (oauth) {
    return <GhOAuthReturn params={oauth} />;
  }
  return <EvidenceViewer initialPack={initialPack} />;
}
